import React, { ReactElement, Component, useState, useEffect, useContext, Dispatch, SetStateAction, useMemo, useCallback } from "react";
import "./breadcrumb.less";
import { Col, Button, Dropdown, Menu, Input, Empty, Typography } from "antd";
import { item } from "../../contexts/items";
import { Link, withRouter } from "react-router-dom";
import { WorkspaceContext, workspaces_type_item } from "../../contexts/workspaces";
import { NamespaceContext, namespaces_type_item } from "../../contexts/namespaces";
import { WorkSpaceSelectedContext } from "../../contexts/workspace-selected";
import { NameSpaceSelectedContext } from "../../contexts/namespace-selected";
import { ClusterSelectedContext } from "../../contexts/cluster-selected";
// import { LeftMenuTitleContext } from '../../contexts/left-menu-title';
import { select_display } from "../table-list/table-list";
import { injectIntl } from "react-intl";
import { SearchOutlined } from "@ant-design/icons";
import { IUserInfoType, UserInfoContext } from "../../contexts/user-info";
import { ClusterContext, clusters_type_item } from "../../contexts/clusters";
import { useDeepCompareMemo } from 'use-deep-compare';

const BreadCrumbs: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [menu_visible, set_menu_visible]: [boolean[], Dispatch<SetStateAction<boolean[]>>] = useState<boolean[]>([false, false, false]),
    user_info: IUserInfoType = useContext(UserInfoContext)[0],
    [search, set_search]: [string[], Dispatch<SetStateAction<string[]>>] = useState<string[]>(["", "", ""]),
    [namespace_menu, set_namespace_menu]: [JSX.Element[], Dispatch<SetStateAction<JSX.Element[]>>] = useState<JSX.Element[]>([] as JSX.Element[]),
    // [level, set_level]: [number, Dispatch<SetStateAction<number>>] = useState<number>(0),
    [workspace_menu, set_workspace_menu]: [JSX.Element[], Dispatch<SetStateAction<JSX.Element[]>>] = useState<JSX.Element[]>([] as JSX.Element[]),
    [cluster_menu, set_cluster_menu]: [JSX.Element[], Dispatch<SetStateAction<JSX.Element[]>>] = useState<JSX.Element[]>([] as JSX.Element[]),
    workspaces: workspaces_type_item[] | undefined = useContext(WorkspaceContext)[0],
    namespaces: namespaces_type_item[] | undefined = useContext(NamespaceContext)[0],
    [workspace_selected, set_workspace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(
      WorkSpaceSelectedContext
    ),
    [namespace_selected, set_namespace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(
      NameSpaceSelectedContext
    ),
    clusters: clusters_type_item[] = useContext(ClusterContext)[0],
    [cluster_selected, set_cluster_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(ClusterSelectedContext),
    // left_menu_title: string = useContext(LeftMenuTitleContext)[0],
    path: string = props.history.location.pathname.substring(1),
    { formatMessage }: { formatMessage: any } = useDeepCompareMemo(() => props.intl, [props.intl]),
    { Text } = useMemo(() => Typography, []),
    is_monitor: boolean = useMemo((): boolean => path.includes("monitor"), [path]);

  useEffect((): void => {
    if (clusters) {
      const data: string = sessionStorage.getItem("cluster") || "",
        selected = Array.isArray(clusters) && clusters.find((cluster: clusters_type_item) => cluster.metadata && cluster.metadata.name === data);
      if (selected) set_cluster_selected(selected.metadata);
      else if (clusters.length) {
        const { metadata }: clusters_type_item = clusters[0];
        set_cluster_selected(metadata);
        set_workspace_selected(undefined);
        set_namespace_selected(undefined);
        sessionStorage.setItem("cluster", metadata?.name);
      } else set_cluster_selected(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clusters, set_cluster_selected]);

  useEffect((): void => {
    // const pathname = props.history.location.pathname,
    //   push = () => { if (pathname.includes('/workspace-info/') || pathname.includes('/namespace-info/')) props.history.push('/cluster-info/workspaces') };
    if (workspaces && Array.isArray(workspaces)) {
      const data: string = sessionStorage.getItem("workspace") || "";
      const selected = workspaces?.find((workspace: workspaces_type_item) => workspace.metadata && workspace.metadata.name === data);
      if (selected) set_workspace_selected(selected.metadata);
      else if (workspaces.length) {
        const { metadata }: workspaces_type_item = workspaces[0];
        set_workspace_selected(metadata);
        set_namespace_selected(undefined);
        sessionStorage.setItem("workspace", metadata?.name);
      } else set_workspace_selected(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaces, set_workspace_selected]);

  useEffect((): void => {
    if (!path.includes("monitor") && namespaces) {
      // const pathname = props.history.location.pathname,
      //   push = () => {
      //     if (pathname.includes('/namespace-info/')) props.history.push('/workspace-info/namespaces');
      //   };
      const data: string = sessionStorage.getItem("namespace") || "",
        selected = Array.isArray(namespaces) && namespaces.find((namespace: namespaces_type_item) => namespace.metadata?.name === data);
      if (selected) set_namespace_selected(selected.metadata);
      else if (namespaces.length) {
        const { metadata }: namespaces_type_item = namespaces[0];
        set_namespace_selected(metadata);
        sessionStorage.setItem("namespace", metadata?.name);
      } else set_namespace_selected(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [set_namespace_selected, namespaces, workspace_selected]);

  // Cluster
  useEffect((): void => {
    let i: number;
    if (Array.isArray(clusters)) {
      const filter_clusters =
        clusters &&
        clusters.filter(
          (item: clusters_type_item) =>
            item.metadata && item.metadata.name && item.metadata.name.toLocaleLowerCase().indexOf(search[0].toLocaleLowerCase().trim()) > -1
        );
      let cluster_menu_new: JSX.Element[] = [
        <Menu.Item
          key={0}
          onClick={(e) => {
            prevent(e);
          }}
        >
          <Input
            className="box_rounded"
            allowClear={true}
            prefix={<SearchOutlined />}
            placeholder="Please input"
            value={search[0]}
            onChange={(e) => {
              set_search([e.target.value, "", ""]);
            }}
          />
        </Menu.Item>,
        <Menu.Item key={"empty"}>
          <Empty />
        </Menu.Item>,
      ];
      let cluster_name: string;
      if (filter_clusters.length > 0) cluster_menu_new = cluster_menu_new.slice(0, 1);
      for (i = 0; i < filter_clusters.length; i++) {
        cluster_name = filter_clusters[i].metadata.name;
        cluster_menu_new.push(
          <Menu.Item key={cluster_name} onClick={select_menu.bind([filter_clusters[i].metadata, 0])}>
            {cluster_name}
          </Menu.Item>
        );
      }
      set_cluster_menu(cluster_menu_new);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clusters, search[0]]);

  // Workspace 選單
  useEffect((): void => {
    let i: number;
    if (Array.isArray(workspaces)) {
      const filter_workspaces =
        workspaces &&
        workspaces.filter(
          (item) =>
            item.metadata.labels &&
            item.metadata.labels.name &&
            item.metadata.labels.name.toLocaleLowerCase().indexOf(search[1].toLocaleLowerCase().trim()) > -1
        );
      let workspace_menu_new: JSX.Element[] = [
        <Menu.Item
          key={0}
          onClick={(e) => {
            prevent(e);
          }}
        >
          <Input
            className="box_rounded"
            allowClear={true}
            prefix={<SearchOutlined />}
            placeholder="Please input"
            value={search[1]}
            onChange={(e) => {
              set_search(["", e.target.value, ""]);
            }}
          />
        </Menu.Item>,
        <Menu.Item key={"empty"}>
          <Empty />
        </Menu.Item>,
      ];
      let workspace_name: string;
      if (filter_workspaces.length > 0) workspace_menu_new = workspace_menu_new.slice(0, 1);
      for (i = 0; i < filter_workspaces.length; i++) {
        workspace_name = filter_workspaces[i].metadata.labels.name;
        workspace_menu_new.push(
          <Menu.Item key={workspace_name + i} onClick={select_menu.bind([filter_workspaces[i].metadata, 1])}>
            {workspace_name}
          </Menu.Item>
        );
      }
      set_workspace_menu(workspace_menu_new);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaces, search[1]]);

  // Namespace 选单
  useEffect((): void => {
    let i: number;
    if (Array.isArray(namespaces)) {
      const filter_namespaces = namespaces.filter((item) => {
        const metadata: namespaces_type_item["metadata"] = item.metadata || {};
        return (
          (metadata.name || "").toLocaleLowerCase().indexOf(search[2].toLocaleLowerCase().trim()) > -1 &&
          (metadata.labels || {}).workspace === workspace_selected?.name
        );
      });
      let namespace_menu_new = [
        <Menu.Item
          key={0}
          onClick={(e) => {
            prevent(e);
          }}
        >
          <Input
            className="box_rounded"
            allowClear={true}
            value={search[2]}
            placeholder="Please input"
            prefix={<SearchOutlined />}
            onChange={(e) => {
              set_search(["", "", e.target.value]);
            }}
          />
        </Menu.Item>,
        <Menu.Item key={"empty"}>
          <Empty />
        </Menu.Item>,
      ];
      let namespace_name: string;
      if (filter_namespaces.length > 0) namespace_menu_new = namespace_menu_new.slice(0, 1);
      for (i = 0; i < filter_namespaces.length; i++) {
        namespace_name = filter_namespaces[i].metadata.name;
        namespace_menu_new.push(
          <Menu.Item key={filter_namespaces[i].metadata.uid} onClick={select_menu.bind([filter_namespaces[i].metadata, 2])}>
            {namespace_name}
          </Menu.Item>
        );
      }
      set_namespace_menu(namespace_menu_new);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [namespaces, search[2], workspace_selected]);

  // useEffect((): void => {
  //   const levels = [
  //     ['Global'],
  //     ['Cluster'],
  //     ['Workspace'],
  //     ['Namespace'],
  //     ['Workload'],
  //   ]

  //   let level_new: number = 0;
  //   for (let i = 0; i < levels.length; i++) {
  //     if (levels[i].indexOf(left_menu_title) > -1) {
  //       level_new = i;
  //       break;
  //     }
  //   }
  //   set_level(level_new);
  // }, [left_menu_title])

  const prevent = useCallback((event: any): void => {
    event.domEvent.preventDefault();
    event.domEvent.stopPropagation();
  }, []),
    empty_menu: JSX.Element = useMemo(
      () => (
        <Menu>
          <Menu.Item>empty</Menu.Item>
        </Menu>
      ),
      []
    ),
    select_menu = useCallback(
      function (this: [item, number], event: any) {
        event.domEvent.preventDefault();
        switch (this[1]) {
          case 0:
            set_cluster_selected(this[0]);
            // user_info.role !== 'workspaceOwner' && user_info.role !== 'namespaceDeveloper' && props.history.push('/cluster-info/overview');
            break;
          case 1:
            set_workspace_selected(this[0]);
            break;
          case 2:
            set_namespace_selected(this[0]);
            break;
        }
        const name = this[0].labels?.name || this[0].name;
        this[0].key && name && sessionStorage.setItem(this[0].key, name);
      },
      [set_cluster_selected, set_namespace_selected, set_workspace_selected]
    ),
    not_search_close = useCallback((e: any, key: number) => {
      if (e.key === "0") {
        if (key === 0) set_menu_visible([true, false, false]);
        else if (key === 1) set_menu_visible([false, true, false]);
        else set_menu_visible([false, false, true]);
      } else {
        set_menu_visible([false, false, false]);
      }
    }, []),
    cluster: JSX.Element | undefined = useMemo(
      () => (
        <span>
          &gt;
          <Link to={user_info.role === "workspaceOwner" || user_info.role === "namespaceDeveloper" ? "#" : "/clusters"}>
            <Dropdown
              overlay={
                <Menu
                  className="space_menu operations"
                  onClick={(e) => {
                    not_search_close(e, 0);
                  }}
                >
                  {!clusters ? empty_menu : cluster_menu}
                </Menu>
              }
              trigger={["hover"]}
              placement="bottomCenter"
              visible={menu_visible[0]}
              onVisibleChange={(e) => {
                set_menu_visible([e, menu_visible[1], menu_visible[2]]);
                set_search(["", "", ""]);
              }}
            >
              <Button size="small" className="breadcrumb_btn">
                {cluster_selected?.name || formatMessage({ id: "empty" })}
              </Button>
            </Dropdown>
          </Link>
          {path.includes("cluster") && !path.includes("namespace") && !path.includes("workspace-info") && (
            <span className="link_title px-6">
              <Text copyable={{ text: (cluster_selected || {}).uid }}>
                <span className="uid_style">{(cluster_selected || {}).uid}</span>
              </Text>
            </span>
          )}
        </span>
      ),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [cluster_menu, cluster_selected, clusters, empty_menu, menu_visible, not_search_close, path, user_info.role, formatMessage]
    ),
    workspace: JSX.Element | undefined = useMemo(
      () => (
        <span>
          &gt;
          <Link to={user_info.role === "namespaceDeveloper" ? "#" : "/cluster-info/workspaces"}>
            <Dropdown
              overlay={
                <Menu
                  className="space_menu operations"
                  onClick={(e) => {
                    not_search_close(e, 1);
                  }}
                >
                  {!workspaces ? empty_menu : workspace_menu}
                </Menu>
              }
              trigger={["hover"]}
              placement="bottomCenter"
              visible={menu_visible[1]}
              onVisibleChange={(e) => {
                set_menu_visible([menu_visible[0], e, menu_visible[2]]);
                set_search(["", "", ""]);
              }}
            >
              <Button size="small" className="breadcrumb_btn">
                {workspace_selected?.labels?.name || formatMessage({ id: is_monitor ? "all" : "empty" })}
              </Button>
            </Dropdown>
          </Link>
          {!path.includes("namespace-info") && path.includes("workspace") && (
            <span className="link_title px-6">
              <Text copyable={{ text: workspace_selected?.name }}>
                <span className="uid_style">{workspace_selected?.name}</span>
              </Text>
            </span>
          )}
        </span>
      ),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [empty_menu, menu_visible, not_search_close, path, user_info.role, workspace_menu, workspace_selected, workspaces, formatMessage, is_monitor]
    ),
    namespace: JSX.Element | undefined = useMemo(
      () => (
        <span>
          &gt;
          <Link to="/workspace-info/namespaces">
            <Dropdown
              overlay={
                <Menu
                  className="space_menu operations"
                  onClick={(e) => {
                    not_search_close(e, 2);
                  }}
                >
                  {!namespaces || !namespaces.length ? empty_menu : namespace_menu}
                </Menu>
              }
              trigger={["hover"]}
              placement="bottomCenter"
              visible={menu_visible[2]}
              onVisibleChange={(e) => {
                set_menu_visible([menu_visible[0], menu_visible[1], e]);
                set_search(["", "", ""]);
              }}
            >
              <Button size="small" className="breadcrumb_btn">
                {namespace_selected?.name || formatMessage({ id: is_monitor ? "all" : "empty" })}
              </Button>
            </Dropdown>
          </Link>
          <span className="link_title px-6">
            <Text copyable={{ text: namespace_selected?.uid }}>
              <span className="uid_style">{namespace_selected?.uid}</span>
            </Text>
          </span>
        </span>
      ),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [empty_menu, menu_visible, namespace_menu, namespace_selected, namespaces, not_search_close, formatMessage, is_monitor]
    );

  return (
    <Col sm={22} className="breadcrumb_header bg_transparent breadcrumb">
      {user_info.role !== "" && (
        <Link to="/console">
          <Button size="small" className="breadcrumb_btn">
            <span className="px-6">Home</span>&gt;
            <span className="px-6">Global</span>
          </Button>
        </Link>
      )}
      <span className="breadcrumb_hide">
        {select_display(path).cluster && !path.includes("ingress-info/ingress") && !path.includes("service-usage") && cluster}
        {select_display(path).workspace && !path.includes("ingress-info/ingress") && !path.includes("service-usage") && workspace}
        {select_display(path).namespace && !path.includes("ingress-info/ingress") && !path.includes("service-usage") && namespace}
        {/* {workload} */}
      </span>
    </Col>
  );
};

export default injectIntl(withRouter(BreadCrumbs) as any);
